import type { ReactNode } from "react";
import { RotateCcw, Search } from "lucide-react";
import { CertificationButton } from "./CertificationButton";

type Props = {
  title: string;
  description?: string;
  visibleCount: number;
  totalCount?: number;
  onReset: () => void;
  children: ReactNode;
  actions?: ReactNode;
};

export function CertificationFilters({
  title,
  description,
  visibleCount,
  totalCount,
  onReset,
  children,
  actions,
}: Props) {
  const countText = totalCount === undefined || totalCount === visibleCount
    ? `${visibleCount} registros visibles`
    : `${visibleCount} de ${totalCount} registros`;

  return (
    <section className="iso27001-filters-panel">
      <div className="iso27001-filters-heading">
        <div>
          <div className="iso27001-filters-eyebrow">
            <Search size={14} />
            Filtros de tabla
          </div>
          <h3>{title}</h3>
          {description ? <p>{description}</p> : null}
        </div>
        <div className="iso27001-filters-actions">
          <span className="iso27001-filter-count">{countText}</span>
          {actions}
          <CertificationButton
            variant="secondary"
            icon={<RotateCcw size={15} />}
            onClick={onReset}
          >
            Limpiar filtros
          </CertificationButton>
        </div>
      </div>
      <div className="iso27001-filters-grid">{children}</div>
    </section>
  );
}
